/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InvalidPromoCodeFieldsFragment = {
  readonly __typename?: 'InvalidPromoCode';
  readonly message: string;
  readonly status: number;
};

export type SubmitPromoCodeMutationVariables = Types.Exact<{
  input: Types.SubmitPromoCodeInput;
}>;

export type SubmitPromoCodeMutation = {
  readonly __typename?: 'Mutation';
  readonly submitPromoCode:
    | {
        readonly __typename: 'InvalidPromoCode';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'SubmitPromoCodeSuccess';
        readonly loyaltyId: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const submitPromoCodeMutationMock: ExecutionResult<SubmitPromoCodeMutation> =
  {
    data: {
      submitPromoCode: {
        __typename: 'InvalidPromoCode',
        message: 'Hello World',
        status: 84,
      },
    },
  };
export const InvalidPromoCodeFieldsFragmentDoc = gql`
  fragment InvalidPromoCodeFields on InvalidPromoCode {
    message
    status
  }
`;
export const SubmitPromoCodeDocument = gql`
  mutation SubmitPromoCode($input: SubmitPromoCodeInput!) {
    submitPromoCode(input: $input) {
      __typename
      ... on SubmitPromoCodeSuccess {
        loyaltyId
      }
      ...ValidationErrorFields
      ...InvalidPromoCodeFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${InvalidPromoCodeFieldsFragmentDoc}
`;

export function useSubmitPromoCodeMutation() {
  return Urql.useMutation<
    SubmitPromoCodeMutation,
    SubmitPromoCodeMutationVariables
  >(SubmitPromoCodeDocument);
}
